import { saveAs } from 'file-saver';
import { toPng } from 'html-to-image';
type ShareableContent = {
  title: string;
  invitationFileURL: string;
  currentUrl: string;
  qrElement?: HTMLElement | null;
};

export const handleDownloadImage = (url: string, fileName?: string) => {
  saveAs(url, fileName ? `${fileName}-invitation.jpg` : 'event-image.jpg');
};

export const downloadQR = async (qrElement: HTMLElement, fileName: string = 'event-qrcode.png') => {
  try {
    const dataUrl = await toPng(qrElement, { quality: 0.95 });
    saveAs(dataUrl, fileName);
  } catch (error) {
    console.error('Error downloading QR code:', error);
    throw error;
  }
};

export const handleShareImage = async (url: string, title?: string) => {
  try {
    const img = await fetch(url).then(r => r.blob());
    const file = new File([img], 'event-invitation.jpg', { type: img.type });

    if (navigator.share) {
      await navigator.share({
        title: title || 'Event Invitation',
        files: [file],
        url: window.location.href
      });
    } else {
      await navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard!');
    }
  } catch (error) {
    console.error('Sharing failed:', error);
    // Fallback to direct download
    handleDownloadImage(url, title);
  }
};

export const shareContent = async (type: 'link' | 'image' | 'qr', content: ShareableContent) => {
  try {
    const { title, invitationFileURL, currentUrl, qrElement } = content;
    const shareData: ShareData & { files?: File[] } = {
      title,
      text: `Join me at ${title}!`,
      url: currentUrl,
    };

    switch (type) {
      case 'image':
        const imageBlob = await fetch(invitationFileURL).then(r => r.blob());
        shareData.files = [new File([imageBlob], 'event-image.jpg', { type: imageBlob.type })];
        break;

      case 'qr':
        if (!qrElement) throw new Error('QR element is required for sharing QR code');
        const qrDataUrl = await toPng(qrElement);
        const qrBlob = await fetch(qrDataUrl).then(r => r.blob());
        shareData.files = [new File([qrBlob], 'event-qrcode.png', { type: 'image/png' })];
        break;
    }

    if (navigator.share) {
      await navigator.share(shareData);
    } else {
      await navigator.clipboard.writeText(currentUrl);
      alert('Link copied to clipboard!');
    }
  } catch (err) {
    console.error('Sharing failed:', err);
    throw err;
  }
};